import { useState } from "react";
import { LoaderBoxCircular } from "../Components/LoaderBox";
import {
  Box, Container, TextField, Grid, Divider, Button, TableContainer, Table,
  TableHead, TableRow, TableCell, Paper, TableBody, Chip, IconButton, Collapse, Typography
} from "@mui/material";
import { ArrowBack, KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { DialogAlert } from "../Components/DialogAlert";
import { instance, validateFunction, functions } from "../Components/config";
import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "../Components/AuthContext";

const CUATRIMESTRES_ORDENADOS = ["Primer", "Segundo", "Tercero"];

const MAPA_CUATRIMESTRES = {
  1: "Primer", 2: "Primer", 3: "Primer", 4: "Primer",
  5: "Segundo", 6: "Segundo", 7: "Segundo", 8: "Segundo",
  9: "Tercero", 10: "Tercero", 11: "Tercero", 12: "Tercero",
};

function FilaDetalle({ item }) {
  const [expandido, setExpandido] = useState(false);

  const totalesPorCuatrimestre = { Primer: 0, Segundo: 0, Tercero: 0 };
  (item.meses || []).forEach(({ idMes, cantidad }) => {
    const cuatri = MAPA_CUATRIMESTRES[idMes];
    if (cuatri) totalesPorCuatrimestre[cuatri] += Number(cantidad || 0);
  });

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton size="small" onClick={() => setExpandido(!expandido)}>
            {expandido ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{item.detalle}</TableCell>
        <TableCell>{item.departamento} · {item.municipio} · {item.localidad}</TableCell>
        <TableCell>{item.metaInicial}</TableCell>
        <TableCell>{item.disminucion}</TableCell>
        <TableCell>{item.incremento}</TableCell>
        <TableCell><strong>{item.metaModificadaFinal}</strong></TableCell>
        <TableCell>{item.justificacion}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
          <Collapse in={expandido} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 2 }}>
              <Typography variant="subtitle2" gutterBottom>Nueva distribución mensual</Typography>
              <Grid container spacing={2}>
                {CUATRIMESTRES_ORDENADOS.map((cuatri) => (
                  <Grid item xs={12} sm={4} key={cuatri}>
                    <Paper variant="outlined" sx={{ p: 1 }}>
                      <Typography variant="body2" fontWeight="bold">{cuatri} cuatrimestre</Typography>
                      {(item.meses || [])
                        .filter((m) => MAPA_CUATRIMESTRES[m.idMes] === cuatri)
                        .map((m) => (
                          <Box key={m.idMes} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Typography variant="body2">{m.mes}</Typography>
                            <Typography variant="body2">{m.cantidad}</Typography>
                          </Box>
                        ))}
                      <Divider sx={{ my: 0.5 }} />
                      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="body2" fontWeight="bold">Subtotal</Typography>
                        <Typography variant="body2" fontWeight="bold">{totalesPorCuatrimestre[cuatri]}</Typography>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

function UPSE8Detalle() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const id = location.state?.id;
  const esRevision = location.state?.validar ?? false;

  const [nombreU2, setNombreU2] = useState("");
  const [anio, setAnio] = useState(0);
  const [idUpse2, setIdUpse2] = useState(0);
  const [techoPresupuestario, setTechoPresupuestario] = useState(0);
  const [fechaPresentacion, setFechaPresentacion] = useState("");
  const [fechaRevision, setFechaRevision] = useState("");
  const [responsable, setResponsable] = useState("");
  const [cargoResponsable, setCargoResponsable] = useState("");
  const [creado, setCreado] = useState("");
  const [cargoCreado, setCargoCreado] = useState("");
  const [idEncargado, setIdEncargado] = useState("");
  const [estado, setEstado] = useState("");
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [fueraDeVentana, setFueraDeVentana] = useState(false);
  const [justificacionFueraVentana, setJustificacionFueraVentana] = useState("");

  const [accion, setAccion] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const [listaDetalle, setListaDetalle] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [dialog, setDialog] = useState({
    title: "",
    text: "",
    redirect: false,
    page: "/UPSE8",
    pageState: {},
  });

  function estadoColor(valor) {
    if (valor === "Aprobado") return "success";
    if (valor === "Rechazado") return "error";
    return "warning";
  }

  function getInfoUPSE() {
    if (id === undefined) {
      navigate("/UPSE8");
    }
    instance.get(`/upse8/listById/${id}`)
      .then((res) => {
        setNombreU2(res.data.nombreU2);
        setAnio(res.data.anio);
        setIdUpse2(res.data.idupse2);
        setTechoPresupuestario(res.data.techoPresupuestario);
        setFechaPresentacion(res.data.fechaPresentacion);
        setFechaRevision(res.data.fechaRevision);
        setResponsable(res.data.responsable);
        setCargoResponsable(res.data.cargoResponsable);
        setIdEncargado(res.data.idResponsable);
        setCreado(res.data.creado);
        setCargoCreado(res.data.cargoCreado);
        setEstado(res.data.estado);
        setMotivoRechazo(res.data.motivoRechazo);
        setFueraDeVentana(!!res.data.fueraDeVentana);
        setJustificacionFueraVentana(res.data.justificacionFueraVentana);
        setListaDetalle(res.data.detalle || []);
      })
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message });
        }
        setOpenDialog(true);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  if (isLoading) {
    getInfoUPSE();
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const comentario = e.target.comentario.value;

    if (accion === "3" && comentario.length === 0) {
      setDialog({
        title: "Aviso",
        text: "Si se va a rechazar el formulario, debe agregar la descripcion del motivo de rechazo u observaciones.",
      });
      setOpenDialog(true);
      return;
    }

    setIsLoading(true);
    instance.post('/upse8/registrarRevision', {
      id,
      motivo: comentario,
      idEstado: accion,
      idEncargado,
      anioMeta: anio,
      idUpse2
    })
      .then(() => {
        setDialog({
          title: "Aviso",
          text: "Se ha registrado correctamente la revision.",
          redirect: true,
          page: "/UPSE8"
        });
      })
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message });
        }
      })
      .finally(() => {
        setIsLoading(false);
        setOpenDialog(true);
      });
  };

  function parsearFecha(fecha) {
    if (!fecha) { return '-'; }
    const fechaFixed = new Date(fecha);
    const yyyy = fechaFixed.getFullYear();
    const MM = String(fechaFixed.getMonth() + 1).padStart(2, '0');
    const dd = String(fechaFixed.getDate()).padStart(2, '0');
    const HH = String(fechaFixed.getHours()).padStart(2, '0');
    const mm = String(fechaFixed.getMinutes()).padStart(2, '0');

    return `${yyyy}-${MM}-${dd} ${HH}:${mm}`;
  }

  return (
    <Container>
      <Box sx={{ marginTop: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)}>Volver</Button>
        <h2 style={{ textAlign: 'center', flex: 1, margin: 0 }}>Detalle de UPSE-8</h2>
        <Chip label={`U8-${id}`} size="small" color="primary" variant="outlined" />
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <LoaderBoxCircular isLoading={isLoading}>
          <Box sx={{ width: '100%', maxWidth: '100%', paddingX: 3, marginBottom: 5 }}>
            <Box
              sx={{
                padding: "4px",
                margin: { xs: 0, sm: 1 },
                border: { xs: "0", sm: "1px solid #000" },
              }}
              component={"form"}
              onSubmit={handleSubmit}
            >
              <Grid
                container
                spacing={3}
                padding={2}
                rowSpacing={1}
                sx={{ alignItems: "center" }}
              >
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                  <h3 style={{ textAlign: 'center', margin: 0, marginRight: 8 }}>Datos generales</h3>
                  {estado && <Chip label={estado} color={estadoColor(estado)} />}
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="UPSE-2" value={nombreU2} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={3} marginTop={2}>
                  <TextField disabled fullWidth label="Año" value={anio} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={3} marginTop={2}>
                  <TextField disabled fullWidth label="Techo presupuestario" value={techoPresupuestario} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="Fecha de presentación" value={parsearFecha(fechaPresentacion)} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="Fecha de revisión" value={parsearFecha(fechaRevision)} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="Planificación" value={`U2-${idUpse2}`} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="Responsable" value={`${creado}${cargoCreado ? ' · ' + cargoCreado : ''}`} InputLabelProps={{ shrink: true }} />
                </Grid>

                <Grid item xs={12} sm={6} marginTop={2}>
                  <TextField disabled fullWidth label="Jefe inmediato / encargado de revisión" value={`${responsable}${cargoResponsable ? ' · ' + cargoResponsable : ''}`} InputLabelProps={{ shrink: true }} />
                </Grid>

                {fueraDeVentana && (
                  <Grid item xs={12} marginTop={2}>
                    <TextField disabled fullWidth multiline label="Justificación por presentación fuera de fecha" value={justificacionFueraVentana} InputLabelProps={{ shrink: true }} />
                  </Grid>
                )}

                {motivoRechazo && (
                  <Grid item xs={12} marginTop={2}>
                    <TextField disabled fullWidth multiline label="Motivo de rechazo" value={motivoRechazo} InputLabelProps={{ shrink: true }} />
                  </Grid>
                )}

                <Grid item xs={12} marginTop={3}>
                  <Divider variant="middle" component="aside" />
                </Grid>

                <Grid item xs={12} sm={12} marginTop={3} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                  <h3 style={{ margin: 0 }}>Detalle de productos reprogramados</h3>
                </Grid>

                <Grid item xs={12}>
                  <TableContainer component={Paper} sx={{ marginTop: 4, overflowX: "auto" }}>
                    <Table size="medium">
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell><strong>Producto</strong></TableCell>
                          <TableCell><strong>Ubicación</strong></TableCell>
                          <TableCell><strong>Meta inicial</strong></TableCell>
                          <TableCell><strong>Disminución</strong></TableCell>
                          <TableCell><strong>Incremento</strong></TableCell>
                          <TableCell><strong>Meta modificada final</strong></TableCell>
                          <TableCell><strong>Justificación</strong></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {listaDetalle.map((item, index) => (
                          <FilaDetalle item={item} key={index} />
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>


                {(esRevision && validateFunction(user, functions.ReviewUPSE8)) &&
                  <>
                    <Grid item sm={1} marginTop={3} />
                    <Grid item xs={12} sm={10} marginTop={3}>
                      <TextField
                        fullWidth
                        label="Comentarios u observaciones"
                        id="comentario"
                        name="comentario"
                        type="text"
                        multiline
                        inputProps={{ maxLength: 1000 }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item sm={1} marginTop={3} />

                    <Grid item sm={3} />
                    <Grid item xs={12} sm={3}>
                      <Button
                        color="error" fullWidth variant="contained" type="submit" onClick={() => setAccion("3")}>Rechazar</Button>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Button
                        fullWidth variant="contained" type="submit" onClick={() => setAccion("2")}>Aprobar</Button>
                    </Grid>
                    <Grid item sm={3} />
                  </>}

              </Grid>
            </Box>
          </Box>
        </LoaderBoxCircular>

        <DialogAlert
          title={dialog.title}
          text={dialog.text}
          open={openDialog}
          setOpen={setOpenDialog}
          redirectOnClose={dialog.redirect}
          page={dialog.page}
          pageState={dialog.pageState}
        />
      </Box>
    </Container>

  );
}

export { UPSE8Detalle };
